import React from 'react';
import ValidationTypes from '../../util/validationTypes';
import { Link } from 'react-router-dom';
import useForm from '../../hooks/formHook.js';
import '../../styles/LandingLogin.css';

export default function LandingLogin({ handleLogin, history }) {
    const loginFormRules = {
        email: [
            ValidationTypes.requiredString,
            ValidationTypes.validEmail
        ],
        password: [ValidationTypes.requiredString]
    };

    const { formData, handleChange, handleSubmit, errorMapping } = useForm({
        email: '',
        password: ''
    }, loginFormRules);

    const handleLoginSuccessful = () => {
        // Do auth here.
        handleLogin();
        if (history.location.state && history.location.state.from) { // If tried to access a page prior to login, will redirect to that page.
            history.push(history.location.state.from);
        }
        else {
            history.push('/');
        }
    };

    return (
        <div className="LandingLogin form">
            <h1>Welcome Back!</h1>
            <form onSubmit={(e) => handleSubmit(e, handleLoginSuccessful)}>
                <input 
                className={errorMapping.email && 'form-error-input'}
                aria-labelledby="email"
                type="text"
                name="email"
                value={formData.email}
                placeholder="Email address" 
                onChange={handleChange} />
                {errorMapping.email && <p className="form-error">{errorMapping.email}</p>}
                <input 
                className={errorMapping.password && 'form-error-input'}
                aria-labelledby="password"
                type="password"
                name="password"
                value={formData.password}
                placeholder="Password" 
                onChange={handleChange} />
                {errorMapping.password && <p className="form-error">{errorMapping.password}</p>}
                <input 
                type="submit"
                value="Sign In" />
            </form>
            <Link to="/resetpassword" className="fine-print">Forgot Password</Link>
        </div>
    )
}